<template>
  <div class="additionals" v-if="attributes">
    <div v-for="attribute in attributes">
      <div class="option" @click="setOption({value: attribute.id, step: step})"
           :class="{ 'selected' : attribute.id === getOptions[step]}">
        <img :src="attribute.image" v-if="attribute.image"/>
        <span class="name">{{ attribute.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import confirmDialog from "../../../mixins/confirm-dialog"
import complementarymDialog from "../../../mixins/complementary-dialog"

export default {
  name: "Additionals",
  props: {
    attributes: {
      type: Array
    },
    step: {
      type: String
    }
  },
  mixins: [confirmDialog, complementarymDialog],
  data () {
    return {
      selectedOption: null
    }
  },
  computed: {
    ...mapGetters({
      getStep: 'customizer/getStep',
      getOptions: 'customizer/getOptions',
      getProduct: 'customizer/getProduct'
    }),
    getSteps() {
      return this.$parent.getSteps
    },
    isMobile() {
      return this.windowWidth <= 680
    }
  },
  watch: {
    getConfirmationDialogConfirm(n) {
      if (!n) {
        return
      }

      this.setOptionAdditionals(this.selectedOption)

      // if (this.getStep.id !== 'pa_rozmiar_lozka') {
      //   this.setAdditionals([])
      // }

      this.fetchVariation(this.getOptions).then(() => {
        if (this.isMobile) {
          document.getElementById('customizer').scrollTo({top: 0, behavior: 'smooth'});
        }
      })
      this.closeConfirmDialog()
    },
    getComplementaryDialogConfirm(n) {
      if (!n) {
        return
      }

      this.setOptionRegural({id: this.selectedOption.step, data: this.selectedOption.value})
      this.setOptionMattress(null)

      this.fetchVariation(this.getOptions).then(() => {
        if (this.isMobile) {
          document.getElementById('customizer').scrollTo({top: 0, behavior: 'smooth'});
        }
      })
      this.closeComplementaryDialog()
    }
  },
  mounted() {
    if (this.getStep) {
      this.setStep({
        ...this.getSteps.find(step => step.id === this.getStep.id),
        completed: !!this.getOptions[this.getStep.id]
      })
    }

    if (!this.attributes.find(attribute => attribute.id === this.getOptions.pa_nogi)) {
      // this.setOptionAdditionals(this.attributes[0].id)
    }
  },
  methods: {
    ...mapMutations({
      setStep: 'customizer/setStep',
      setOptionAdditionals: 'customizer/setOptionAdditionals',
      setOptionMattress: 'customizer/setOptionMattress',
      setOptionRegural: 'customizer/setOption'
    }),
    ...mapActions({
      fetchVariation: 'customizer/fetchVariation'
    }),
    setOption(value) {
      this.selectedOption = null
      if (this.compareValues(value.value, this.getOptions[value.step]) && (this.getStep.id !== 'pa_rozmiar_lozka' && this.getStep.id !== 'pa_pojemnik')) {
        this.selectedOption = value
        this.openConfirmDialog()
        return
      }

      if (this.compareValuesComplementary(value.value, this.getOptions[value.step]) && (this.getStep.id === 'pa_rozmiar_lozka' && this.getStep.id !== 'pa_pojemnik')) {
        this.selectedOption = value
        this.openComplementaryDialog()
        return
      }

      this.setOptionAdditionals(value)

      this.fetchVariation(this.getOptions).then(() => {
        if (this.isMobile) {
          document.getElementById('customizer').scrollTo({top: 0, behavior: 'smooth'});
        }
      })
    },
    changeWCVariation() {
      const options = JSON.parse(JSON.stringify(this.getOptions))

      delete options.pa_additionals
      delete options.group

      let form = new FormData()

      Object.keys(options).forEach((item) => {
        if (options[item]) {
          form.append('attribute_' + item, options[item])

          const select = document.querySelector(`select#${item}`)
          if (select) {
            select.value = options[item]
            select.dispatchEvent(new Event("change", {"bubbles": true}))
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.additionals {
  padding: 25px 15px;
  @media (max-width: 480px) {
    padding: 25px 0;
  }
  max-height: 610px;
  overflow-y: auto;

  .option {
    display: flex;
    align-items: center;
    padding: 15px;
    border: 1px solid #efefef;
    border-radius: 4px;
    margin-bottom: 10px;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    color: #3C3C3C;
    transition: all .2s;

    @media (max-width: 480px) {
      font-size: 14px;
    }

    img {
      margin: 0 15px 0 0;
    }

    &.selected {
      border: 1px solid #3c3c3c;
    }

    &:hover {
      border: 1px solid #3c3c3c;
    }
  }
}
</style>
